(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoiceDialogController', InvoiceDialogController);

    InvoiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'category',
        '$q', 'entity', 'Invoice', 'Keyword', 'InvoicePayment', 'ActivityHistory',
        'Comment', 'Shipment', '$state', 'LotCustomService', 'InvoicePriceCustomService',
        '$uibModal', 'InvoiceCustomService', 'Principal',
        'ContractCustomService', 'InvoiceDialogProvider', 'FixationCustomService', 'ToastrService',
        'CompanyCustomService', 'CommentCustomService', 'AttachmentCustomService', '$rootScope',
        'ShipmentCustomService', 'KeywordCustomService', 'MiscService'];

    function InvoiceDialogController ($timeout, $scope, $stateParams, category,
                                      $q, entity, Invoice, Keyword, InvoicePayment, ActivityHistory,
                                      Comment, Shipment, $state, LotCustomService, InvoicePriceCustomService,
                                      $uibModal, InvoiceCustomService, Principal, ContractCustomService,
                                      InvoiceDialogProvider, FixationCustomService, ToastrService,
                                      CompanyCustomService, CommentCustomService, AttachmentCustomService, $rootScope,
                                      ShipmentCustomService, KeywordCustomService, MiscService ) {

        var vm = this;
        vm.invoice = entity;
        vm.category = category;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.initAddInvoicePrice = initAddInvoicePrice;
        vm.save = save;
        vm.calculateLotData = calculateLotData;
        vm.enterNewInvoiceBank = enterNewInvoiceBank;
        vm.applyPrecision = applyPrecision;
        vm.updateAndApplyPrecision = updateAndApplyPrecision;
        vm.setPrecision = setPrecision;
        vm.onCommissionValueChanged = onCommissionValueChanged;
        vm.nl2br = MiscService.nl2br;

        vm.pricePrecisions = [0,1,2,3,4,5];
        vm.weightPrecisions = [0,1,2,3,4,5];
        vm.valuePrecisions = [0,1,2,3,4,5];

        function updateAndApplyPrecision(precision, val) {
            if (precision === 1) {
                vm.invoice.pricePrecision = val;
            } else if (precision === 2) {
                vm.invoice.weightPrecision = val;
            } else if (precision === 3) {
                vm.invoice.valuePrecision = val;
            }
            vm.applyPrecision();
        }

        function applyPrecision() {
            for (var i = 0; i < vm.invoicePrices.length; i++) {
                if (vm.invoicePrices[i].priceDisplay && vm.invoicePrices[i].priceDisplay !== vm.invoicePrices[i].price) {
                    vm.invoicePrices[i].price = vm.invoicePrices[i].priceDisplay;
                }
                if (vm.invoicePrices[i].editedPriceValueDisplay && vm.invoicePrices[i].editedPriceValue !== vm.invoicePrices[i].editedPriceValueDisplay) {
                    vm.invoicePrices[i].editedPriceValue = vm.invoicePrices[i].editedPriceValueDisplay;
                }

                if (vm.invoicePrices[i].ncontractPriceDisplay && vm.invoicePrices[i].ncontractPriceDisplay !== vm.invoicePrices[i].ncontractPrice) {
                    vm.invoicePrices[i].ncontractPrice = vm.invoicePrices[i].ncontractPriceDisplay;
                }
                if (vm.invoicePrices[i].ncontractPriceValueDisplay && vm.invoicePrices[i].ncontractPriceValue !== vm.invoicePrices[i].ncontractPriceValueDisplay) {
                    vm.invoicePrices[i].ncontractPriceValue = vm.invoicePrices[i].ncontractPriceValueDisplay;
                }
                if(vm.invoicePrices[i].qty && vm.invoicePrices[i].qty !== undefined) {
                    vm.invoicePrices[i].qty = setPrecision(vm.invoicePrices[i].qty, vm.invoice.weightPrecision);
                }
                if(vm.invoicePrices[i].aBalance && vm.invoicePrices[i] !== undefined) {
                    vm.invoicePrices[i].aBalance = setPrecision(vm.invoicePrices[i].aBalance, vm.invoice.weightPrecision);
                }

                vm.invoicePrices[i].priceDisplay = vm.setPrecision(vm.invoicePrices[i].price, vm.invoice.pricePrecision);
                vm.invoicePrices[i].editedPriceValueDisplay = vm.setPrecision(vm.invoicePrices[i].editedPriceValue, vm.invoice.valuePrecision);

                vm.invoicePrices[i].ncontractPriceDisplay = vm.setPrecision(vm.invoicePrices[i].ncontractPrice, vm.invoice.pricePrecision);
                vm.invoicePrices[i].ncontractPriceValueDisplay = vm.setPrecision(vm.invoicePrices[i].ncontractPriceValue, vm.invoice.valuePrecision);

                vm.editedTotalValue = vm.setPrecision(vm.editedTotalValue, vm.invoice.valuePrecision);
                vm.totalNContractValue = vm.setPrecision(vm.totalNContractValue, vm.invoice.valuePrecision);
                vm.editedTotalValueEur = vm.setPrecision(vm.editedTotalValueEur, vm.invoice.valuePrecision);

                vm.invoice.editedTotalValue = vm.setPrecision(vm.invoice.editedTotalValue, vm.invoice.valuePrecision);
                vm.invoice.editedTotalValueEur = vm.setPrecision(vm.invoice.editedTotalValueEur, vm.invoice.valuePrecision);

                vm.invoicePrices[i].weightDisplay = vm.setPrecision(vm.invoicePrices[i].weight, vm.invoice.weightPrecision);
                vm.invoicePrices[i].weightInLbsDisplay = vm.setPrecision(vm.invoicePrices[i].weightInLbs, vm.invoice.weightPrecision);
                vm.invoicePrices[i].weightInKgsDisplay = vm.setPrecision(vm.invoicePrices[i].weightInKgs, vm.invoice.weightPrecision);
                vm.invoicePrices[i].weightInMtsDisplay = vm.setPrecision(vm.invoicePrices[i].weightInMts, vm.invoice.weightPrecision);
            }

            if (vm.invoice.commissionValue && vm.invoice.commissionValueDisplay && vm.invoice.commissionValueDisplay !== vm.invoice.commissionValue) {
                vm.invoice.commissionValue = vm.invoice.commissionValueDisplay;
            }

            vm.invoice.commissionValueDisplay = vm.setPrecision(vm.invoice.commissionValue, vm.invoice.valuePrecision);// vm.setPrecision(InvoiceDialogProvider.calculateCommissionValue(vm), vm.invoice.valuePrecision);
        }

        vm.createTab = function (data) {
            $scope.$emit('handleEmit', data);
        };

        vm.wtconversiontypes = Keyword.query({filter: 'invoice-is-null'});
        $q.all([vm.invoice.$promise, vm.wtconversiontypes.$promise]).then(function() {
            if (!vm.invoice.wtConversionType || !vm.invoice.wtConversionType.id) {
                return $q.reject();
            }
            return Keyword.get({id : vm.invoice.wtConversionType.id}).$promise;
        }).then(function(wtConversionType) {
            vm.wtconversiontypes.push(wtConversionType);
        });
        vm.invpricetypes = Keyword.query({filter: 'invoice-is-null'});
        $q.all([vm.invoice.$promise, vm.invpricetypes.$promise]).then(function() {
            if (!vm.invoice.invPriceType || !vm.invoice.invPriceType.id) {
                return $q.reject();
            }
            return Keyword.get({id : vm.invoice.invPriceType.id}).$promise;
        }).then(function(invPriceType) {
            vm.invpricetypes.push(invPriceType);
        });

        vm.commissionDescriptions = [];
        KeywordCustomService.returnKeywordsByType("CommissionDescription").then(function (data) {
            vm.commissionDescriptions = data.data;
            for (var i = 0; i < vm.commissionDescriptions.length; i++) {
                if (vm.commissionDescriptions[i].keyword === vm.invoice.commissionDescription) {
                    vm.invoice.commissionDescription = vm.commissionDescriptions[i];
                    break;
                }
            }
        }, function (error) {
            vm.commissionDescriptions = [];
            console.log(error.status, error.statusText);
        });

        $scope.enterNewKeyword = function(type) {
            $uibModal.open({
                templateUrl: 'app/entities/keyword/keyword-dialog.html',
                controller: 'KeywordDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: "user",
                            modifiedOn: new Date(),
                            modifiedBy: "user",
                            type: type,
                            value: null,
                            desc: null,
                            id: null
                        };
                    }
                }
            }).result.then(function (retVal) {
                vm.commissionDescriptions.push(retVal);
                vm.invoice.commissionDescription = retVal;
                vm.invoice.commissionDescriptionDisplay = retVal.keyword;
            }, function (error) {
                console.log(error.status, error.statusText)
            });
        };

        vm.invoicepayments = InvoicePayment.query();
        vm.comments = [];
        vm.comment = "";
        vm.attachments = [];
        if( vm.invoice.id !== null ) {
            resolveComments();
            resolveAttachments();
        }
        vm.shipments = [];
        vm.shipmentContracts = [];
        vm.selectedShipment = null;
        vm.onQueryingShipmentNumber = onQueryingShipmentNumber;
        vm.onShipmentNumberSelected = onShipmentNumberSelected;
        vm.initInvoicePrice = initInvoicePrice;
        vm.initContracts = initContracts;
        vm.updateInvoicePriceIndex = updateInvoicePriceIndex;
        vm.account = {};
        // ----------------- 144 ---------------------
        vm.initialInvoice = angular.copy(entity);
        vm.onContractSelected = onContractSelected;
        vm.loadFixations = loadFixations;
        vm.transformFixation = transformFixation;
        vm.onFixationSelected = onFixationSelected;
        vm.onFixationFixedSelected = onFixationFixedSelected;
        vm.findFixationById = findFixationById;
        vm.findLotById = findLotById;
        vm.calculateTotalWeight = calculateTotalWeight;
        vm.calculateTotalQty = calculateTotalQty;
        vm.calculateTotalMt = calculateTotalMt;
        vm.calculateAvgNContractPrice = calculateAvgNContractPrice;
        vm.calculateTotalNContractValue = calculateTotalNContractValue;
        vm.calculateTotalWeightLb = calculateTotalWeightLb;
        vm.calculateCommissionValue = calculateCommissionValue;
        vm.calculateTotalValue = calculateTotalValue;
        vm.calculateTotalOverrideValue = calculateTotalOverrideValue;
        vm.calculateAvgPrice = calculateAvgPrice;
        vm.onQuantityChanged = onQuantityChanged;
        vm.onPriceChanged = onPriceChanged;
        vm.onNContractPriceChanged = onNContractPriceChanged;
        vm.activateUnitType = activateUnitType;
        vm.togglePp = togglePp;
        vm.loadInvoiceBanks = loadInvoiceBanks;
        vm.resolveDates = resolveDates;
        vm.onCommissionRateChanged = onCommissionRateChanged;
        vm.addPrePayment = addPrePayment;
        vm.addNContractPrePayment = addNContractPrePayment;
        vm.reindexPrePayment = reindexPrePayment;
        vm.reindexNContractPrePayment = reindexNContractPrePayment;
        vm.savePrePayments = savePrePayments;
        vm.deletePrePayment = deletePrePayment;
        vm.deleteNContractPrePayment = deleteNContractPrePayment;
        vm.onPrePaymentsLoaded = onPrePaymentsLoaded;
        vm.updateEditedTotalValue = updateEditedTotalValue;
        vm.shipmentLots = [];
        vm.allLots = [];
        vm.invoicePrices = [];
        vm.firstLoading = true;
        vm.defaultUnitType = 'KG';
        vm.defaultUnitTypeUS = 'LB';
        vm.editedTotalValue = 0;
        vm.totalNContractValue = 0;
        vm.editedTotalValueEur = 0;
        vm.unitTypes = ['LB', 'MT', 'KG'];
        vm.provisionalPriceOptions = [
            {display: 'NO', value: false},
            {display: 'YES', value: true}
        ];

        vm.paymentBanks = [];
        if (vm.category.type === 'SALE') {
            vm.loadInvoiceBanks();
        }

        vm.prePayments = [];
        function addPrePayment() {
            vm.prePayments.push({
                amount: 0,
                nContract: false
            });
            vm.reindexPrePayment();
        }
        function reindexPrePayment() {
            for (var i = 0; i < vm.prePayments.length; i++) {
                var key = 'prePayment' + (i + 1);
                vm.prePayments[i].index = i + 1;
                vm.prePayments[i].key = key;
                vm.datePickerOpenStatus[key] = false;
            }
        }
        function savePrePayments() {
            var allPrePaymentsList = [];
            angular.forEach(vm.prePayments, function (pp) {
                pp.invoice = { id: vm.invoice.id };
                allPrePaymentsList.push(pp);
            });
            angular.forEach(vm.nContractPrePayments, function (pp) {
                pp.invoice = { id: vm.invoice.id };
                allPrePaymentsList.push(pp);
            });
            InvoiceCustomService.saveInvoicePrePayments(vm.invoice.id, allPrePaymentsList).then(function (data) {
                vm.onPrePaymentsLoaded(data);
            }, function (error) {
                console.log(error.status, error.statusText);
            });
        }
        function deletePrePayment(prePayment) {
            var indexToDelete = -1;
            for (var i = 0; i < vm.prePayments.length; i++) {
                if (vm.prePayments[i].index === prePayment.index) {
                    indexToDelete = i;
                }
            }
            if (indexToDelete > -1) {
                vm.prePayments.splice(indexToDelete, 1);
                vm.reindexPrePayment();
            }
        }

        vm.nContractPrePayments = [];
        function addNContractPrePayment() {
            vm.nContractPrePayments.push({
                amount: 0,
                nContract: true
            });
            vm.reindexNContractPrePayment();
        }
        function reindexNContractPrePayment() {
            for (var i = 0; i < vm.nContractPrePayments.length; i++) {
                var key = 'nContractPrePayment' + (i + 1);
                vm.nContractPrePayments[i].index = i + 1;
                vm.nContractPrePayments[i].key = key;
                vm.datePickerOpenStatus[key] = false;
            }
        }
        function deleteNContractPrePayment(prePayment) {
            var indexToDelete = -1;
            for (var i = 0; i < vm.nContractPrePayments.length; i++) {
                if (vm.nContractPrePayments[i].index === prePayment.index) {
                    indexToDelete = i;
                }
            }
            if (indexToDelete > -1) {
                vm.nContractPrePayments.splice(indexToDelete, 1);
                vm.reindexPrePayment();
            }
        }

        resolveDates();

        if (vm.invoice.id > 0) {
            InvoiceCustomService.returnInvoicePrePayments(vm.invoice.id).then(function (data) {
                vm.onPrePaymentsLoaded(data);
            }, function (error) {
                vm.prePayments = [];
                console.log(error.status, error.statusText);
            });
        }

        function onPrePaymentsLoaded(data) {
            vm.prePayments = [];
            vm.nContractPrePayments = [];
            for (var i = 0; i < data.data.length; i++) {
                if (data.data[i].nContract) {
                    vm.nContractPrePayments.push(data.data[i]);
                } else {
                    vm.prePayments.push(data.data[i]);
                }
            }
            for (i = 0; i < vm.prePayments.length; i++) {
                if (vm.prePayments[i].prePaymentDate !== null) {
                    vm.prePayments[i].prePaymentDate = new Date(vm.prePayments[i].prePaymentDate);
                }
            }
            for (i = 0; i < vm.nContractPrePayments.length; i++) {
                if (vm.nContractPrePayments[i].prePaymentDate !== null) {
                    vm.nContractPrePayments[i].prePaymentDate = new Date(vm.nContractPrePayments[i].prePaymentDate);
                }
            }
            vm.reindexPrePayment();
            vm.reindexNContractPrePayment();
        }

        function onCommissionRateChanged() {
            vm.invoice.commissionValue = vm.setPrecision(InvoiceDialogProvider.calculateCommissionValue(vm), vm.invoice.valuePrecision);
            vm.invoice.commissionValueDisplay = angular.copy(vm.invoice.commissionValue);
        }

        function loadInvoiceBanks(idToSelect) {
            CompanyCustomService.returnCompaniesByType('INVOICE_BANK').then(function (data) {
                vm.paymentBanks = data.data;
                for (var j = 0; j < vm.paymentBanks.length; j++) {
                    if (vm.paymentBanks[j].shortName && vm.paymentBanks[j].shortName.length > 0) {
                        vm.paymentBanks[j].label = vm.paymentBanks[j].shortName + ' (' + vm.paymentBanks[j].name + ')';
                    } else {
                        vm.paymentBanks[j].label = vm.paymentBanks[j].name;
                    }
                }
                // TODO check how to init without cycle
                if ((idToSelect && idToSelect > 0) || (vm.invoice && vm.invoice.paymentBank)) {
                    for (var i = 0; i < vm.paymentBanks.length; i++) {
                        if ((vm.invoice && vm.invoice.paymentBank && vm.paymentBanks[i].id === vm.invoice.paymentBank.id)
                                || (idToSelect && idToSelect > 0 && vm.paymentBanks[i].id === idToSelect)) {
                            vm.invoice.paymentBank = vm.paymentBanks[i];
                            break;
                        }
                    }
                }
            }, function () {
                ToastrService.error("Payment banks not found", "Error!");
                vm.paymentBanks = [];
            });
        }

        function onContractSelected() {
            if (vm.invoice.selectedContract && vm.invoice.selectedContract !== null &&
                vm.initialInvoice.selectedContract && vm.initialInvoice.selectedContract !== null &&
                vm.invoice.selectedContract.id !== vm.initialInvoice.selectedContract.id) {
                vm.firstLoading = false;
            }
            if (vm.invoice.selectedContract) {
                if (vm.invoice.invWtUnits === undefined || vm.invoice.invWtUnits === null) {
                    vm.invoice.invWtUnits = vm.invoice.selectedContract.unitType;
                }
                LotCustomService.getMinifiedLotsForInvoiceDialogByContractTypeAndContractAndShipment(vm.invoice.selectedContract.contractType, vm.invoice.selectedContract.id, vm.invoice.shipment.id).then(function(data) {
                    onLotsLoaded(data.data);
                }, function() {
                    onLotsLoaded([]);
                });
            }

            function onLotsLoaded(lots) {
                vm.contractLots = lots;
                InvoiceDialogProvider.composeInvoicePrices(vm);
                vm.calculateLotData();
                vm.loadFixations();
                if (!vm.invoice.commissionValue) {
                    vm.invoice.commissionValue = InvoiceDialogProvider.calculateCommissionValue(vm);
                }
				$timeout(function() {
				    vm.applyPrecision(false);
				}, 1);
            }
        }

        function activateUnitType(unitType) {
            vm.invoice.invWtUnits = unitType;
            InvoiceDialogProvider.updateValuesWithNewUnitType(vm);
            vm.onCommissionRateChanged();
            vm.applyPrecision(false);
        }

        function togglePp(pp) {
            vm.invoice.isProvisionalPrice = pp.value;
        }

        function loadFixations() {
            if (vm.invoice.selectedContract && vm.invoice.selectedContract.priceModel === 'ONCALL') {
                FixationCustomService.getMinifiedFixationsForInvoiceDialogByContract(vm.invoice.selectedContract.id).then(function (data) {
                    vm.fixationsList = data.data;
                    for (var i = 0; i < vm.fixationsList.length; i++) {
                        vm.transformFixation(vm.fixationsList[i]);
                        getAppliedQtyForFixation(vm.fixationsList[i]);
                    }
                }, function () {
                    ToastrService.error("Fixations not found", "Error!");
                    vm.fixationsList = [];
                });
            } else {
                vm.fixationsList = [];
            }
        }

        function transformFixation(fixation) {
            fixation.label = 'Price ' + fixation.pricing.label + '-' + fixation.label + ': ' + fixation.pricing.price + ' with Future Price: ' + fixation.futurePrice + ', Final Price: ' + fixation.finalPriceFixationAmount
                + (fixation.pricing ? (' from ' + fixation.pricing.month + ', ' + fixation.pricing.year + ' of Pricing') : '');
        }

        function getAppliedQtyForFixation(fixation) {
            fixation.appliedQty = 0;
            if( vm.invoice.id === null) {
                InvoicePriceCustomService.returnFixationAppliedQtyNoInvoice(fixation.id).then(function(data) {
                    fixation.appliedQty = data.data;
                    computeAvailableBalanceForFixation(fixation);
                }, function(error) {
                    if(error.status !== 404) {
                        ToastrService.error("Failed to get fixation applied Qty with id: " + fixation.id);
                    }
                });
            } else {
                InvoicePriceCustomService.returnFixationAppliedQtyWithInvoice(fixation.id, vm.invoice.id).then(function (data) {
                    fixation.appliedQty = data.data;
                    computeAvailableBalanceForFixation(fixation);
                }, function (error) {
                    if (error.status !== 404) {
                        ToastrService.error("Failed to get fixation applied Qty with id: " + fixation.id);
                    }
                });
            }
        }

        function onFixationSelected(row) {
            if (row.fixation && row.fixation > 0) {
                var fixationObject = findFixationById(row.fixation);
                if (fixationObject) {
                    var varPrice = fixationObject.finalPriceFixationAmount;
                    if (vm.invoice.selectedContract.contractType === "SALE" && (vm.invoice.selectedContract.category === "TUI" || vm.invoice.selectedContract.category==="JAPAN") && ( vm.invoice.selectedContract.subCategory === "OUTSIDE" || vm.invoice.selectedContract.subCategory === "JAPAN" )) {
                        var varNPrice = fixationObject.interCompPrice;
                        row.ncontractPrice = varNPrice;
                        row.ncontractPriceDisplay = varNPrice;
                        row.ncontractPriceValue = (InvoiceDialogProvider.getWeight(vm, row) * row.ncontractPrice / InvoiceDialogProvider.getPriceTypeDivider(vm));
                        row.ncontractPriceValueDisplay = setPrecision(row.ncontractPriceValue, vm.invoice.valuePrecision);
                        vm.totalNContractValue = InvoiceDialogProvider.calculateTotalNContractValue(vm);
                    }
                    row.price = varPrice;
                    row.priceDisplay = varPrice;
                    row.priceValue = (InvoiceDialogProvider.getWeight(vm, row) * row.price / InvoiceDialogProvider.getPriceTypeDivider(vm));
                    row.editedPriceValue = angular.copy(row.priceValue);
                    row.editedPriceValueDisplay = vm.setPrecision( row.editedPriceValue, vm.invoice.valuePrecision );
                    if( vm.invoice.currency !== "EUR" ) {
                        vm.editedTotalValue = InvoiceDialogProvider.calculateTotalOverrideValue(vm);
                    } else {
                        vm.editedTotalValueEur = InvoiceDialogProvider.calculateTotalOverrideValue(vm);
                    }
                }
                computeAvailableBalanceForAllFixations();
            } else if (vm.invoice.selectedContract.priceModel === 'FIXED') {
                onFixationFixedSelected( row, vm.invoice.selectedContract.fixedPrice );
            }
        }

        function computeAvailableBalanceForAllFixations() {
            if(vm.fixationsList) {
                for(var i = 0; i < vm.fixationsList.length; i++) {
                    computeAvailableBalanceForFixation(vm.fixationsList[i]);
                }
            }
        }

        function computeAvailableBalanceForFixation(fixation) {
            var qty = fixation.quantity;
            var applied = fixation.appliedQty;
            var balance = qty - applied;
            if(vm.invoicePrices) {
                for(var i = 0; i < vm.invoicePrices.length; i++) {
                    if(vm.invoicePrices[i].fixation === fixation.id && vm.invoicePrices[i].lot && vm.invoicePrices[i].lot !== null) {
                        vm.invoicePrices[i].qty = fixation.quantity + " " + fixation.unitType;
                        var lotQty = returnLotQty(fixation, vm.invoicePrices[i].lot);
                        applied = applied + lotQty;
                        balance = balance - lotQty;
                    }
                }
                fixation.appliedQtyInInvoice = setPrecision(applied, vm.invoice.weightPrecision);
                fixation.balanceQtyInInvoice = setPrecision(balance, vm.invoice.weightPrecision);
                for(var i = 0; i < vm.invoicePrices.length; i++) {
                    if(vm.invoicePrices[i].fixation === fixation.id && vm.invoicePrices[i].lot && vm.invoicePrices[i].lot !== null) {
                        vm.invoicePrices[i].aBalance = fixation.balanceQtyInInvoice;
                    }
                }
            }
        }

        function returnLotQty(fixation, lot) {
            var lotQty = fixation.unitType === "BALES" ? lot.qtyBales : lot.lotWeightMts;
            if(isNaN(lotQty)) {
                lotQty = parseFloat(lotQty);
            }
            return lotQty;
        }

        function setPrecision(originalValue, scale) {
            var result = parseFloat(originalValue).toFixed(scale);
            return isNaN(result) ? 0 : result;
        }

        function onFixationFixedSelected(row, value) {
            var editMode = vm.invoice && vm.invoice !== null && vm.invoice.id && vm.invoice.id > 0 && vm.invoice.shipment && vm.invoice.shipment.id && vm.invoice.shipment.id > 0;
            if (value && !editMode) {
                row.price = value;
                row.priceValue = (InvoiceDialogProvider.getWeight(vm, row) * row.price / InvoiceDialogProvider.getPriceTypeDivider(vm));
                row.editedPriceValue = angular.copy(row.priceValue);
                if( vm.invoice.currency !== "EUR" ) {
                    vm.editedTotalValue = InvoiceDialogProvider.calculateTotalOverrideValue(vm);
                } else {
                    vm.editedTotalValueEur = InvoiceDialogProvider.calculateTotalOverrideValue(vm);
                }
                vm.totalNContractValue = InvoiceDialogProvider.calculateTotalNContractValue(vm);
            }
        }

        function findFixationById(id) {
            if (vm.fixationsList) {
                for (var i = 0; i < vm.fixationsList.length; i++) {
                    if (vm.fixationsList[i].id === id) {
                        return vm.fixationsList[i];
                    }
                }
            }
            return undefined;
        }

        function findIndexOfFixationById(id) {
            if(vm.fixationsList) {
                for(var i = 0; i < vm.fixationsList.length; i++) {
                    if(vm.fixationsList[i].id === id) {
                        return i;
                    }
                }
            }
            return undefined;
        }

        function findLotById(id) {
           if (vm.allLots) {
               for (var i = 0; i < vm.allLots.length; i++) {
                   if (vm.allLots[i].id === id) {
                       return vm.allLots[i];
                   }
               }
           }
           return undefined;
        }

        function calculateTotalWeight() {
            return InvoiceDialogProvider.calculateTotalWeight(vm);
        }

        function calculateTotalQty() {
            return InvoiceDialogProvider.calculateTotalQty(vm);
        }

        function calculateTotalMt() {
            return InvoiceDialogProvider.calculateTotalMt(vm);
        }

        function calculateAvgNContractPrice() {
            return InvoiceDialogProvider.calculateAvgNContractPrice(vm);
        }

        function calculateTotalNContractValue() {
            return InvoiceDialogProvider.calculateTotalNContractValue(vm);
        }

        function calculateTotalWeightLb() {
            return InvoiceDialogProvider.calculateTotalWeightLb(vm);
        }

        function calculateCommissionValue() {
            return InvoiceDialogProvider.calculateCommissionValue(vm);
        }

        function calculateTotalValue() {
            return InvoiceDialogProvider.calculateTotalValue(vm);
        }

        function calculateTotalOverrideValue(ip) {
            if (ip && ip.editedPriceValueDisplay && ip.editedPriceValueDisplay !== ip.editedPriceValue) {
                ip.editedPriceValue = ip.editedPriceValueDisplay;
            }
            if( vm.invoice.currency !== "EUR" ) {
                vm.editedTotalValue = InvoiceDialogProvider.calculateTotalOverrideValue(vm);
            } else {
                vm.editedTotalValueEur = InvoiceDialogProvider.calculateTotalOverrideValue(vm);
            }
        }

        function onQuantityChanged(row) {
            InvoiceDialogProvider.onQuantityChanged(vm, row);
        }

        function calculateAvgPrice() {
            return InvoiceDialogProvider.calculateAvgPrice(vm);
        }

        function onPriceChanged(ip) {
            InvoiceDialogProvider.onPriceChanged(vm, ip);
        }

        function onNContractPriceChanged(ip) {
            InvoiceDialogProvider.onNContractPriceChanged(vm, ip);
        }

        function onCommissionValueChanged() {
            InvoiceDialogProvider.onCommissionValueChanged(vm);
        }

        // ------------------------------------------

        // ---------------- START NContracts ------------------
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        $scope.ncontractDate = {
            opened: false
        };
        $scope.openNcontractDate = function () {
            $scope.ncontractDate.opened = true;
        };
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.ncontractDate = false;
        vm.updateNContractInvNum = updateNContractInvNum;

        function resolveDates() {
            if (vm.invoice.ncontractDate !== null) {
                vm.invoice.ncontractDate = MiscService.dateFix( vm.invoice.ncontractDate );
            }
            if( vm.invoice.invDate !== null ) {
                vm.invoice.invDate = MiscService.dateFix( vm.invoice.invDate );
            }
            if( vm.invoice.invDueDate !== null ) {
                vm.invoice.invDueDate = MiscService.dateFix( vm.invoice.invDueDate );
            }
            if( vm.invoice.estPayment !== null ) {
                vm.invoice.estPayment = MiscService.dateFix( vm.invoice.estPayment );
            }
        }

        function updateNContractInvNum() {
            // var lastCharacter = vm.invoice.invNum[vm.invoice.invNum.length -1];
            // if(lastCharacter === "I" || lastCharacter === "i") {
            //     vm.invoice.ncontractInvNumber = vm.invoice.invNum.slice(0, vm.invoice.invNum.length-1);
            // }
        }
        // ---------------- END NContracts ------------------

        var shipmentId = 0;
        if (vm.invoice && vm.invoice.shipment && vm.invoice.shipment.id && vm.invoice.shipment.id > 0) {
            shipmentId = vm.invoice.shipment.id;
        } else if ($stateParams.shipmentId && $stateParams.shipmentId > 0) {
            shipmentId = $stateParams.shipmentId;
        }

        if (shipmentId > 0) {
            ShipmentCustomService.getMinifiedShipmentForInvoiceDialogByShipmentId(shipmentId).then(function(data) {
                vm.invoice.shipment = data.data;
                vm.onShipmentNumberSelected(vm.invoice.shipment, vm.invoice.shipment, '');
                if(vm.invoice.id && vm.invoice.id > 0) {
                    vm.initInvoicePrice();
                }
            }, function() {

            });
        }

        Principal.identity().then(function (account) {
            vm.account = account;
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function initInvoicePrice() {
            vm.invoicePriceList = [];
            vm.onContractSelected();
            if (vm.invoice && vm.invoice.shipment && vm.invoice.shipment.id && vm.invoice.shipment.id > 0) {
                // InvoiceCustomService.returnInvoicePricesByInvoice(vm.invoice.id, vm.invoice.invType ).then(function (result) {
                InvoiceCustomService.getMinifiedInvoicePricesByInvoice(vm.invoice.id, vm.invoice.invType ).then(function (result) {
                    vm.invoicePrices = result.data;
                    InvoiceDialogProvider.initInvoicePrices(vm);
                    if (!vm.invoice.commissionValue) {
                        vm.invoice.commissionValue = InvoiceDialogProvider.calculateCommissionValue(vm);
                    }
                    $timeout(function() {
                        vm.applyPrecision(false);
                    }, 1);
                }, function () {
                    vm.invoicePrices = [];
                });
            }
        }

        function initContracts() {
            vm.shipmentContracts = [];
            if (vm.invoice && vm.invoice.shipment && vm.invoice.shipment.id && vm.invoice.shipment.id > 0) {
                ContractCustomService.returnMinifiedContractsForInvoiceDialogByShipmentIdAndInvType(vm.invoice.shipment.id, vm.category.type).then(function (result) {
                    vm.shipmentContracts = result.data;
                    if (vm.invoice && vm.invoice.selectedContract && vm.invoice.selectedContract.id > 0) {
                        vm.shipmentContracts.unshift(vm.invoice.selectedContract);
                    }
                }, function () {
                    vm.shipmentContracts = [];
                });
            }
        }

        function updateInvoicePriceIndex() {
            for (var i = 0; i < vm.invoicePriceList.length; i++) {
                vm.invoicePriceList[i].index = i + 1;
            }
        }

        function save () {
            vm.isSaving = true;
            var invoicePricesCopy = angular.copy(vm.invoicePrices);
            if (invoicePricesCopy) {
                for (var i = 0; i < invoicePricesCopy.length; i++) {
                    if (angular.isNumber(invoicePricesCopy[i].fixation)) {
                        invoicePricesCopy[i].fixation = findFixationById(invoicePricesCopy[i].fixation);
                    }
                    invoicePricesCopy[i].shipment = angular.copy(vm.invoice.shipment);
                }
            }
            vm.invoice.invoicePrices = invoicePricesCopy;
            InvoiceDialogProvider.applyAggregatedFields(vm);
            if (vm.invoice.commissionDescription) {
                vm.invoice.commissionDescription = vm.invoice.commissionDescription.keyword;
            }
            vm.applyPrecision();
            if (vm.invoice.id !== null) {
                Invoice.update(vm.invoice, onSaveSuccess, onSaveError);
            } else {
                Invoice.save(vm.invoice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            var newInvoice = vm.invoice.id === null;
            vm.invoice.id = result.id;
            if (newInvoice) {
                var promlist = [];
                if (vm.comments.length > 0) {
                    var comments = [];
                    for (var x = 0; x < vm.comments.length; x++) {
                        if (vm.comments[x].id === null) {
                            comments.push(vm.comments[x]);
                        }
                    }
                    if (comments.length > 0) {
                        promlist.push(CommentCustomService.assignParentToComment(vm.comments, vm.invoice.id, "invoice"));
                    }
                }
                if ($scope.files.length > 0) {
                    angular.forEach($scope.files, function (file) {
                        promlist.push(AttachmentCustomService.uploadAttachment(file, "invoice", vm.invoice.id, file.name));
                    });
                }
                var allPrePaymentsList = [];
                if (vm.prePayments.length > 0) {
                    angular.forEach(vm.prePayments, function (pp) {
                        pp.invoice = { id: vm.invoice.id };
                        allPrePaymentsList.push(pp);
                    });
                }
                if (vm.nContractPrePayments.length > 0) {
                    angular.forEach(vm.nContractPrePayments, function (pp) {
                        pp.invoice = {id: vm.invoice.id};
                        allPrePaymentsList.push(pp);
                    });
                }
                promlist.push(InvoiceCustomService.saveInvoicePrePayments(vm.invoice.id, allPrePaymentsList));
                if (promlist.length > 0) {
                    $q.all(promlist).then(function () {
                        finalizeSave();
                    }).then(function () {
                        finalizeSave();
                    });
                } else {
                    finalizeSave();
                }
            } else {
                savePrePayments();
                finalizeSave();
            }
        }

        function finalizeSave() {
            vm.isSaving = false;
            var data = {
                heading: 'Detail ' + vm.invoice.invNum,
                route: 'shipment.shipment-detail',
                id: vm.invoice.id,
                param: {id: ''}
            };
            if (vm.category.type === 'SALE' || vm.category.type === 'JAPAN') {
                data.route = 'invoice-sale.invoice-sale-detail';
            } else if (vm.category.type === 'PURCHASE') {
                data.route = 'invoice-purchase.invoice-purchase-detail';
            }
            resolveDates();
            $rootScope.$emit('handleEmit', data);
        }

        function onSaveError () {
            resolveDates();
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdOn = false;
        vm.datePickerOpenStatus.modifiedOn = false;
        vm.datePickerOpenStatus.invDate = false;
        vm.datePickerOpenStatus.invDueDate = false;
        vm.datePickerOpenStatus.estPayment = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function onQueryingShipmentNumber(keyword) {
            var list = ShipmentCustomService.searchShipmentsForEligibleInvoice(keyword, vm.category.type).then(function(response) {
                return response.data;
            });
            return list;
        }

        function onShipmentNumberSelected($item) {
            var shipmentId = $item.id;
            ShipmentCustomService.getMinifiedShipmentForInvoiceDialogByShipmentId(shipmentId).then(function(data) {
                vm.invoice.shipment = data.data;
                if(vm.category.type === 'SALE') {
                    vm.invoice.selectedContract = vm.invoice.shipment.saleContract;
                    vm.onContractSelected();
                } else {
                    vm.initContracts();
                }
            }, function() {

            });
        }

        function calculateLotData() {
            if (vm.contractLots && vm.contractLots !== null && vm.contractLots.length > 0) {
                var lot = sumLotsData(vm.contractLots, vm.invoice.invType);

                vm.invoice.invGrossKgs = lot.grossKgs;
                vm.invoice.invNetKgs = lot.netKgs;
                vm.invoice.invTareKgs = lot.tareKgs;

                vm.invoice.landedGrossKgs = lot.landedGrossKgs;
                vm.invoice.landedTareKgs = lot.landedTareKgs;
                vm.invoice.landedNetKgs = lot.landedNetKgs;

                vm.invoice.invGrossLbs = lot.grossLbs;
                vm.invoice.invNetLbs = lot.netLbs;
                vm.invoice.invTareLbs = lot.tareLbs;

                vm.invoice.landedGrossLbs = lot.landedGrossLbs;
                vm.invoice.landedTareLbs = lot.landedTareLbs;
                vm.invoice.landedNetLbs = lot.landedNetLbs;

                vm.invoice.invGrossMTs = lot.grossMTs;
                vm.invoice.invNetMTs = lot.netMTs;
                vm.invoice.invTareMTs = lot.tareMTs;

                vm.invoice.landedGrossMTs = lot.landedGrossMTs;
                vm.invoice.landedTareMTs = lot.landedTareMTs;
                vm.invoice.landedNetMTs = lot.landedNetMTs;
            }
        }

        function sumLotsData(lots, invoiceType) {
            var lot = {};
            lot.grossKgs = 0;
            lot.netKgs = 0;
            lot.tareKgs = 0;

            lot.landedGrossKgs = 0;
            lot.landedTareKgs = 0;
            lot.landedNetKgs = 0;

            lot.grossLbs = 0;
            lot.netLbs = 0;
            lot.tareLbs = 0;

            lot.landedGrossLbs = 0;
            lot.landedTareLbs = 0;
            lot.landedNetLbs = 0;

            lot.grossMTs = 0;
            lot.netMTs = 0;
            lot.tareMTs = 0;

            lot.landedGrossMTs = 0;
            lot.landedTareMTs = 0;
            lot.landedNetMTs = 0;

            angular.forEach(lots, function(value) {
                lot.grossKgs += value.purchGrossKgs;
                lot.netKgs += value.purchNetKgs;
                lot.tareKgs += value.purchTareKgs;

                lot.landedGrossKgs += value.purchLandedGrossKgs;
                lot.landedTareKgs += value.purchLandedTareKgs;
                lot.landedNetKgs += value.purchLandedNetKgs;

                lot.grossLbs += value.purchGrossLbs;
                lot.netLbs += value.purchNetLbs;
                lot.tareLbs += value.purchTareLbs;

                lot.landedGrossLbs += value.purchLandedGrossLbs;
                lot.landedTareLbs += value.purchLandedTareLbs;
                lot.landedNetLbs += value.purchLandedNetLbs;

                lot.grossMTs += value.purchGrossMTs;
                lot.netMTs += value.purchNetMTs;
                lot.tareMTs += value.purchTareMTs;

                lot.landedGrossMTs += value.purchLandedGrossMTs;
                lot.landedTareMTs += value.purchLandedTareMTs;
                lot.landedNetMTs += value.purchLandedNetMTs;
            });
            return lot;
        }

        function initAddInvoicePrice() {
            InvoiceDialogProvider.addInvoicePrice(vm);
        }

        function enterNewInvoiceBank() {
            $uibModal.open({
                templateUrl: 'app/entities/company/company-dialog.html',
                controller: 'CompanyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: null,
                            modifiedOn: new Date(),
                            modifiedBy: null,
                            name: null,
                            shortName: null,
                            accountNum: null,
                            type: null,
                            id: null
                        };
                    },
                    showTypes: function () {
                        return false;
                    }
                }
            }).result.then(function (retVal) {
                vm.loadInvoiceBanks(retVal.id);
            }, function (error) {
                console.log(error.status, error.statusText)
            });
        }

        /*
        ANYTHING TO DO WITH COMMENTS
         */
        vm.addComment = addComment;
        vm.editComment = editComment;
        vm.editUnsavedComment = editUnsavedComment;
        vm.verifyCommentDelete = verifyCommentDelete;
        vm.verifyCommentUnsavedDelete = verifyCommentUnsavedDelete;

        //action behind the add comment button
        function addComment() {
            if( vm.comment.length > 0 ) { //if there is actual comment
                //create comment object then push to lot.comments
                if( vm.invoice.id !== null ) { //save comment
                    var comment = [];
                    comment.push( createComment( vm.comment ) );
                    CommentCustomService.assignParentToComment( comment, vm.invoice.id, "invoice" ).then( function() {
                        resolveComments();
                        ToastrService.success( "Added Comment to Invoice", "Success!" );
                    }, function( error ) {
                        ToastrService.error("Failed to save comment: " + error.statusText, "Error");
                        console.log( error.statusText );
                    });
                } else { //push to array to be saved along with the lot
                    vm.comments.push( createComment( vm.comment ) );
                    ToastrService.info( "Added Comment to Invoice", "Info" );
                }
                //clear comment text area
                vm.comment = "";
            }
        };

        //create comment object
        function createComment( comment ) {
            var by = "user";
            if( vm.account.login !== undefined ) {
                by = vm.account.login;
            }
            var com = {
                "id": null,
                "createdOn": new Date(),
                "createdBy": by,
                "modifiedOn": new Date(),
                "modifiedBy": by,
                "comment": comment,
                "active": true
            };
            return com;
        }

        //edit existing comment
        function editComment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-dialog.html',
                controller: 'CommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return vm.comments[ index ];
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return Invoice.get({ id: vm.invoice.id }).$promise;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    },
                    controllerEntity: function() {
                        return null;
                    },
                    controllerPaymentEntity: function() {
                        return null;
                    }
                }
            }).result.then( function( retVal ) {
                ToastrService.success( "Successfully Updated Comment", "Success!" );
                vm.comments[ index ] = retVal;
            });
        };

        //edit comment saved in memory
        function editUnsavedComment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-unsaved-dialog.html',
                controller: 'CommentUnsavedDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return vm.comments[index];
                    }
                }
            }).result.then( function( retVal ) {
                ToastrService.success( "Successfully Updated Comment", "Success!" );
                vm.comments[ index ] = retVal;
            });
        };

        //delete existing comment
        function verifyCommentDelete( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-delete-dialog.html',
                controller: 'CommentDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return vm.comments[index];
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return Invoice.get({ id: vm.invoice.id }).$promise;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    }
                }
            }).result.then( function( retVal ) {
                if( retVal == true ) {
                    ToastrService.success( "Successfully deleted Comment", "Success!" );
                    vm.comments.splice( index, 1 );
                } else {
                    ToastrService.error( "Something went wrong", "Error!" );
                }
            });
        };

        //delete comment saved in memory
        function verifyCommentUnsavedDelete( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-unsaved-delete-dialog.html',
                controller: 'CommentUnsavedDeleteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return vm.comments[ index ];
                    }
                }
            }).result.then( function( retVal ) {
                if( retVal == true ) {
                    ToastrService.success( "Successfully deleted Comment", "Success!" );
                    vm.comments.splice( index, 1 );
                } else {
                    ToastrService.error( "Something went wrong", "Error!" );
                }
            });
        };

        function resolveComments() {
            vm.comments.length = 0;
            CommentCustomService.returnCommentsByInvoice( vm.invoice.id ).then( function( data ) {
                vm.comments = data.data;
                // if( vm.comments.length > 0 ) {
                //     ToastrService.success( "Fetched Comments", "Success!");
                // }
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Cannot get Comments: " + error.statusText, "Error!" );
                }
                console.log( error.statusText );
            });
        }

        /*
        ANYTHING TO DO WITH ATTACHMENTS
         */
        //attachment actions
        vm.deleteTempAttachment = deleteTempAttachment;
        vm.downloadAttachment = downloadAttachment;
        vm.deleteAttachment = deleteAttachment;
        //file uploading
        $scope.files = [];
        $scope.uploadFile = function (file) {
            if( file && file.length ) {
                angular.forEach( file, function( file ) {
                    $scope.files.push( file );
                    if( vm.invoice.id !== null ) {
                        AttachmentCustomService.uploadAttachment( file, "invoice", vm.invoice.id, file.name ).then( function( data ) {
                            vm.attachments.push( data.data );
                            ToastrService.success( "Successfully uploaded attachment", "Success!" );
                        }, function( error ) {
                            if( error.status !== 404 ) {
                                ToastrService.error( "Something went wrong with the attachment: " + error.statusText, "Error" );
                            }
                            console.log( error.statusText );
                        });
                        var index = $scope.files.indexOf( file );
                        $scope.files.splice( index, 1 );
                    }
                });
            }
        };

        function deleteTempAttachment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-remove-modal.html',
                controller: 'AttachmentRemoveModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return $scope.files[index];
                    }
                }
            }).result.then(function (retVal) {
                if (retVal === true) {
                    $scope.files.splice( index, 1 );
                    ToastrService.success("Successfully removed Attachment", "Success!");
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        }

        function downloadAttachment( attachment ) {
            AttachmentCustomService.downloadAttachment( attachment.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/octet-stream'});
                saveAs(file, attachment.fileName );
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Something went wrong: " + error.statusText, "Error");
                    console.log( error.statusText );
                }
            });
        }

        function deleteAttachment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-delete-modal.html',
                controller: 'AttachmentDeleteModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function () {
                        return vm.attachments[index];
                    }
                }
            }).result.then(function (retVal) {
                if (retVal === true) {
                    vm.attachments.splice( index, 1 );
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        }

        function resolveAttachments() {
            vm.attachments.length = 0;
            AttachmentCustomService.returnAttachmentsByInvoice( vm.invoice.id ).then( function( data ) {
                vm.attachments = data.data;
                // if( vm.attachments.length > 0 ) {
                //     ToastrService.success( "Fetched Attachments", "Success!" );
                // }
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Failed to get Attachments: " + error.statusText, "Error" );
                }
                console.log( error.statusText );
            });
        }

        function updateEditedTotalValue() {
            if( vm.invoice.currency === 'EUR' ) {
                vm.editedTotalValue = vm.invoice.editedTotalValue;
            }
        }
    }
})();
